import { colors } from '@configs/Theme';
import Icon, { IconName } from '@utilities/icon';

export interface RateCardProps {
  iconName?: string;
  iconColor?: string;
  text?: string;
  label: string;
}

const RateCard = ({
  iconName,
  text,
  label,
  iconColor = colors.green[400],
}: RateCardProps) => {
  return (
    <div className="w-full flex flex-col justify-center items-center bg-[#F8F9FA] min-w-[104px] min-h-full rounded-xl py-2">
      <div className="flex items-center justify-between gap-x-1">
        {iconName && (
          <Icon
            name={iconName as IconName}
            width={1}
            height={1}
            fill={iconColor}
          />
        )}
        <span className="text-Label/xSmall">{text}</span>
      </div>
      <div>
        <span className="text-Label/2xSmall text-gray-600">{label}</span>
      </div>
    </div>
  );
};

export default RateCard;
